import ParameterFieldBase, { IParameterFieldBaseOptions } from './ParameterFieldBase';

import EditComponent from '../tsx/ColorMappingForNumericField'; //LL 10.01.18 TRY

export class ColorMappingForNumericField extends ParameterFieldBase<IParameterFieldBaseOptions> {
    public static defaultValidators = [];

    public static EditComponent = EditComponent;

    public static getDefaultValue() {
        return [];
    }

    constructor(glob, title: string, validators?: any, defaultVal?: any, options?) {
        if (defaultVal == null) {
            defaultVal = ColorMappingForNumericField.getDefaultValue();
        }

        super(glob, title, ColorMappingForNumericField.defaultValidators, validators, defaultVal, options);
    }
}
